import React from 'react';
import AtlasV2DorisDoubleDropdownChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisDoubleDropdownChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { useDorisEntityDropdownOptions } from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2TotalTrafficV2/AtlasV2TotalTrafficDoubleDropdownTopEntity';
import { GroupByField } from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2TotalTrafficV2/AtlasV2TrafficDropdownTopEntityTraffic';

const AtlasUnitsSoldNon1PDropdownTopEntityChart = ({ groupByFields }: { groupByFields?: GroupByField[] }) => {
  const dropdownOptions = useDorisEntityDropdownOptions('sales');

  return (
    <AtlasV2DorisDoubleDropdownChart
      groupByFields={groupByFields || dropdownOptions}
      fields={[
        {
          fieldName: 'unitsSold',
          label: 'Units Sold',
          metricType: 'unitsSold',
          metricTypeDisplay: METRICTYPE.VOLUME
        }
      ]}
      queryKey="unitsSold_doubleDropdownTopEntityChart"
      endPoint="sales/GetSalesMetrics"
    />
  );
};
export default AtlasUnitsSoldNon1PDropdownTopEntityChart;
